/* unplugin-vue-components disabled */import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"

import "./404.vue?vue&type=style&index=0&id=50a1c389&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a1c389"]])

export default __exports__